import LoadScene from '@scenes/LoadScene';
import GameScene from '@scenes/GameScene';
import HintScene from '@scenes/HintScene';
import StartScene from '@scenes/StartScene';
import EndScene from '@scenes/EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'GameScene', scene: GameScene },
  { key: 'HintScene', scene: HintScene },
  { key: 'StartScene', scene: StartScene },
  { key: 'EndScene', scene: EndScene },
];
